import {ChangeDetectorRef, Component} from '@angular/core';
import {CmsComponentData} from '@spartacus/storefront';
import {
  CmsFlexComponentData
} from '../../checkout/order-confirmation/order-confirmation-list-item/order-confirmation-order-item.model';
import {ComponentService} from '../../services/component.service';
import {first} from 'rxjs/operators';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

/**
 * this component is extended by multiple components.
 * It can be used anywhere where texts are received from commerce cloud.
 */
@UntilDestroy()
@Component({
  selector: 'dcp-fetch-texts',
  template: '',
})
export class FetchTextsComponent {

  componentTexts: any;

  constructor(
    protected cmsData: CmsComponentData<CmsFlexComponentData>,
    protected componentService: ComponentService,
    protected cdr: ChangeDetectorRef,
  ) {
  }


  fetchComponentData() {
    this.componentService.fetchClassificationsProductData(this.cmsData)
      .pipe(first(), untilDestroyed(this))
      .subscribe(componentData => {
        this.componentTexts = componentData?.texts;
        this.cdr.detectChanges();
      });
  }
}
